import { tickerItems } from "@/mocks/homeMeta";

export default function Ticker() {
  const loop = [...tickerItems, ...tickerItems];

  return (
    <div className="w-full bg-foreground-950 text-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="h-11 flex items-center gap-4">
          <div className="flex items-center gap-2 shrink-0">
            <span className="w-2 h-2 rounded-full bg-primary-400 kd-pulse-dot" />
            <span className="text-xs font-label tracking-widest text-primary-300">
              实时滚动
            </span>
          </div>
          <div className="w-px h-4 bg-background-50/20 shrink-0" />
          <div className="flex-1 overflow-hidden">
            <div className="flex w-max animate-marquee">
              {loop.map((item, idx) => (
                <span
                  key={`${item}-${idx}`}
                  className="text-xs md:text-sm font-label text-background-50/85 pr-10 whitespace-nowrap"
                >
                  {item}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}